import { Component, Input, OnInit } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';

@Component({
  selector: 'app-matspinner',
  templateUrl: './matspinner.component.html',
  styleUrls: ['./matspinner.component.css']
})
export class MatspinnerComponent implements OnInit {

  @Input() value : number = 100;
  @Input() diameter: number = 100;
  @Input() mode : string ="indeterminate";
  @Input() strokeWidth : number = 10;
  @Input() overlay: boolean = false;
  @Input() color: string = "primary";
  language!:number;

  constructor(private localStorage:LocalStorageService) { }

  ngOnInit(): void {
    this.language = this.localStorage.retrieve("lang"); 
  }

}
